import { PropType, defineComponent, ref } from 'vue'

import { CsCopyTextLink, CsShareModal } from '@sunrise/components'
import { MsCopy, MsDisabled, MsEnvelope, MsFacebook, MsPrint, MsSocialShare } from '@sunrise/icons'
import { useGlobalStore } from '@sunrise/shared'
import { MLM, TrackingParameter, track } from '@sunrise/tracking'

import { DecoratedEstate } from '../../ts/mapper/decoratedItemEstate.interface'
import { ActionIds } from '../../ts/tracking/mlmActionIds.enum'
import MsWhatsappSvg from './icons/whatsapp.svg?component'

import MsDetailModalReport from '../MsDetailModalReport/MsDetailModalReport.vue'
import MsLikeButton from '../MsLikeButton/MsLikeButton.vue'
import { buildMlmTrackingData, buildTealiumTracking } from './MsShareBarTracking'

export default defineComponent({
    name: 'MsShareBar',
    components: {
        CsCopyTextLink,
        CsShareModal,
        MsPrint,
        MsSocialShare,
        MsDisabled,
        MsFacebook,
        MsWhatsappSvg,
        MsEnvelope,
        MsCopy,
        MsDetailModalReport,
        MsLikeButton,
    },
    props: {
        headline: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        exposeeId: {
            type: Number,
            required: true,
        },
        parentName: {
            type: String,
            required: true,
        },
        estate: {
            type: Object as PropType<DecoratedEstate>,
            required: true,
        },
        showReportButton: {
            type: Boolean,
            default: false,
        },
    },

    setup(props) {
        const requestContext = useGlobalStore().requestContext
        const currentUrl = requestContext?.url.href || ''

        const modalIsVisible = ref<boolean>(false)
        const isShareVisible = ref(false)

        const shareTrackingData: TrackingParameter = buildTealiumTracking(props.exposeeId, 'link_teilen')
        const openTrackingData: TrackingParameter = buildTealiumTracking(props.exposeeId, 'link_teilen', 'default')

        function openShare(): void {
            const mlmTrackingData = buildMlmTrackingData(
                ActionIds.SHARE_OPEN_DROPDOWN,
                props.parentName,
                currentUrl,
                props.exposeeId,
            )
            MLM.trackClick(mlmTrackingData)

            isShareVisible.value = true
        }

        function printExpose(): void {
            const mlmTrackingData = buildMlmTrackingData(
                ActionIds.SHARE_CLICK_PRINT,
                props.parentName,
                currentUrl,
                props.exposeeId,
            )
            MLM.trackClick(mlmTrackingData)
            const tealiumData = buildTealiumTracking(props.exposeeId, 'drucken', 'default')
            track(tealiumData)
            window.print()
        }

        function openReportModal(): void {
            modalIsVisible.value = true

            const tealiumData: TrackingParameter = buildTealiumTracking(props.exposeeId, 'expose_melden', 'default')
            track(tealiumData)
        }

        function closeModal(): void {
            modalIsVisible.value = false
        }

        return {
            modalIsVisible,
            isShareVisible,
            currentUrl,
            shareTrackingData,
            openTrackingData,
            printExpose,
            openReportModal,
            openShare,
            closeModal,
        }
    },
})
